import { assertUnreachable } from '@kindo/universal';

import { TabNavigator, TabOption } from '../core';
import { WorkflowBuilder } from '../WorkflowBuilder';
import { WorkflowFactory } from '../WorkflowFactory';
import { WorkflowLibrary } from '../WorkflowLibrary';

import {
  WorkflowNavTab,
  WORKFLOWS_NAV_TAB_DISPLAY_NAMES,
  WORKFLOWS_NAV_TAB_ROUTES
} from './WorkflowNavScreen.consts';

import { Layout } from 'components/Layout';
import { WORKFLOWS_ROUTE } from '~/constants';
import { useParseWorkflowUrlSlug, useTabUrlNavigation } from '~/hooks';

const DEFAULT_ACTIVE_TAB = WorkflowNavTab.LIBRARY;

const WorkflowNavScreen = () => {
  const { workflowId } = useParseWorkflowUrlSlug();

  const { activeTab, getTabRoute } = useTabUrlNavigation<WorkflowNavTab>({
    defaultActiveTab: DEFAULT_ACTIVE_TAB,
    tabsWithRoutes: WORKFLOWS_NAV_TAB_ROUTES,
    baseRoute: WORKFLOWS_ROUTE
  });

  const tabOptions: TabOption<WorkflowNavTab>[] = [
    WorkflowNavTab.LIBRARY,
    WorkflowNavTab.CREATE
  ].map((tab) => ({
    label: WORKFLOWS_NAV_TAB_DISPLAY_NAMES[tab],
    value: tab,
    href: getTabRoute(tab)
  }));

  const renderActiveTab = () => {
    switch (activeTab) {
      case WorkflowNavTab.LIBRARY:
        return <WorkflowLibrary />;
      case WorkflowNavTab.CREATE:
        return workflowId ? <WorkflowBuilder /> : <WorkflowFactory />;
      default:
        return assertUnreachable(activeTab);
    }
  };

  return (
    <Layout>
      <div
        className="flex flex-1 flex-col overflow-hidden"
        data-testid="workflow-screen-container"
      >
        {!workflowId && (
          <div
            className="flex flex-col items-center gap-4 pb-2 pt-6"
            data-testid="tab-navigator-container"
          >
            <TabNavigator activeTab={activeTab} tabOptions={tabOptions} />
          </div>
        )}
        <div
          className="flex flex-1 flex-col items-center overflow-hidden"
          data-testid="workflow-nav-tab-container"
        >
          <div
            className="flex h-full w-full min-w-[800px] max-w-[50%] flex-col overflow-y-auto p-[1px] pt-4"
            data-testid="tab-content-container"
          >
            {renderActiveTab()}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default WorkflowNavScreen;
